module.exports = __webpack_public_path__ + "static/media/log1.864737d6.jpg";